import { useEffect, useRef } from 'react';

export function useOnMount(callback: () => void) {
  const ref = useRef(false);

  useEffect(() => {
    if (ref.current) return;
    ref.current = true;

    callback();
  }, []);
}
